<template>
  <div>
    <div v-if="isLoading_quiz">
      <semipolar-spinner
        :animation-duration="2000"
        :size="80"
        color="blue"
      ></semipolar-spinner>
    </div>
    <div v-else>
      <CRow class="gridstyle" v-for="(item, index) in items[0]" :key="index">
        <CCol lg="3" md="6" sm="12">
          <transition name="fade">
            <CCard>
              <CCardHeader>
                <div class="card-header-actions">
                  <CLink
                    :href="item.url_to_get_token"
                    target="_blank"
                    class="card-header-action btn-close"
                  >
                    <!-- <CIcon name="cil-plus" /> -->
                    <i
                      v-if="item.access_token_valid"
                      class="fa fa-check"
                      style="color: green"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-else
                      class="fa fa-times"
                      style="color: red"
                      aria-hidden="true"
                    ></i>
                  </CLink>
                </div>
              </CCardHeader>
              <CCardBody class="text-center">
                <!-- <CIcon width="60" height="60" name="cibFacebookF" /> -->
                <CLink
                  :href="item.url_to_get_token"
                  target="_blank"
                  class="card-header-action btn-close"
                >
                  <!-- <a :href="item.url_to_get_token"> -->
                  <CImg thumbnail fluid src="img/GMB.jpg" class="p-2" />
                  <!-- src="https://cfcdn.streetfightmag.com/wp-content/uploads/GMB-723x391.jpg" -->
                  <!-- </a> -->
                </CLink>
              </CCardBody>
              <CCardFooter align="center">
                <div>{{ item.name }}</div>
              </CCardFooter>
            </CCard>
          </transition>
        </CCol>

        <CCol lg="3" md="6" sm="12">
          <transition name="fade">
            <CCard>
              <CCardHeader>
                <div class="card-header-actions">
                  <CLink
                    :href="item.f_url_to_get_token"
                    target="_blank"
                    class="card-header-action"
                  >
                    <i
                      v-if="item.f_access_token_valid"
                      class="fa fa-check"
                      style="color: green"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-else
                      class="fa fa-times"
                      style="color: red"
                      aria-hidden="true"
                    ></i>
                  </CLink>
                </div>
              </CCardHeader>
              <CCardBody class="text-center">
                <!-- <CIcon width="60" height="60" name="cibFacebookF" /> -->
                <CLink
                  :href="item.f_url_to_get_token"
                  target="_blank"
                  class="card-header-action btn-close"
                >
                  <!-- <a :href="item.f_url_to_get_token"> -->
                  <CImg thumbnail fluid class="p-2" src="img/fb.jpg" />
                  <!--                   src="data:image/png;base64,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"
 -->
                  <!-- </a> -->
                </CLink>
              </CCardBody>
              <CCardFooter align="center">
                <div>{{ item.name }}</div>
              </CCardFooter>
            </CCard>
          </transition>
        </CCol>

        <CCol lg="3" md="6" sm="12">
          <transition name="fade">
            <CCard>
              <CCardHeader>
                <div class="card-header-actions">
                  <CLink
                    :href="item.fs_url_to_get_token"
                    target="_blank"
                    class="card-header-action btn-close"
                  >
                    <i
                      v-if="item.fs_access_token_valid"
                      class="fa fa-check"
                      style="color: green"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-else
                      class="fa fa-times"
                      style="color: red"
                      aria-hidden="true"
                    ></i>
                  </CLink>
                </div>
              </CCardHeader>
              <CCardBody class="text-center">
                <!-- <CIcon width="60" height="60" name="cibFacebookF" /> -->
                <!-- <CImg source="../../public/img/GMB.jpg" /> -->
                <CLink
                  :href="item.fs_url_to_get_token"
                  target="_blank"
                  class="card-header-action btn-close"
                >
                  <!-- <a :href="item.fs_url_to_get_token"> -->
                  <CImg thumbnail class="p-2" src="img/Foursquare.jpg" />
                  <!--                   src="https://venturebeat.com/wp-content/uploads/2018/10/Foursquare-on-color-14.png?fit=800%2C240&strip=all" -->

                  <!-- </a> -->
                </CLink>
              </CCardBody>
              <CCardFooter align="center">
                <div>{{ item.name }}</div>
              </CCardFooter>
            </CCard>
          </transition>
        </CCol>

        <CCol lg="3" md="6" sm="12">
          <transition name="fade">
            <CCard>
              <CCardHeader>
                <div class="card-header-actions">
                  <CLink
                    :href="item.t_url_to_get_token"
                    target="_blank"
                    class="card-header-action btn-close"
                  >
                    <i
                      v-if="item.t_access_token_valid"
                      class="fa fa-check"
                      style="color: green"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-else
                      class="fa fa-times"
                      style="color: red"
                      aria-hidden="true"
                    ></i>
                  </CLink>
                </div>
              </CCardHeader>
              <CCardBody class="text-center">
                <!-- <CIcon width="60" height="60" name="cibFacebookF" /> -->
                <!-- <CImg source="../../public/img/GMB.jpg" /> -->
                <CLink
                  :href="item.t_url_to_get_token"
                  target="_blank"
                  class="card-header-action btn-close"
                >
                  <!-- <a :href="item.fs_url_to_get_token"> -->
                  <CImg thumbnail class="p-2" src="img/TrustpilotIcon.jpg" />
                  <!-- src="img/TrustpilotIcon.png" -->

                  <!-- <i style="color: green;"  class="p-4 fas fa-star fa-10x"></i> -->
                  <!-- </a> -->
                </CLink>
              </CCardBody>
              <CCardFooter align="center">
                <div>{{ item.name }}</div>
              </CCardFooter>
            </CCard>
          </transition>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import store from "../store";
import { shuffleArray } from "@/shared/utils";

export default {
  name: "MainPage",
  data: function () {
    return {
      access_token_valid: false,
      f_access_token_valid: true,
      fs_access_token_valid: false,
      items: [],
      show: true,
      isCollapsed: true,
      isloading: false,
      loremIpsum:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
    };
  },
  mounted() {
    this.getSettingAccount();
  },
  methods: {
    getSettingAccount() {
      var gbaaccounts = store.getters.getSettingAccount;
      if (gbaaccounts.length == 0) {
        this.isLoading = true;
        store.dispatch("getSettingAccount").then(() => {
          gbaaccounts = store.getters.getSettingAccount;
          shuffleArray([gbaaccounts]);
          this.items = gbaaccounts;
          this.itemsArray = gbaaccounts;
          this.isLoading = false;
          // console.log("gba_items array::::::===>", this.itemsArray);
          //console.log("items accounts settings ::::::===>", this.items);
        });
      } else {
        shuffleArray([gbaaccounts]);
        this.items = gbaaccounts;
        this.itemsArray = gbaaccounts;
      }
    },
  },
};
</script>

<style >
.gridstyle .col-md-4 {
  display: grid;
}
</style>